<template>
  <div v-if="!!phaseData">
    <v-expansion-panels class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-header> EXAMES GERAIS </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col>
              <v-btn color="white" class="primary--text" @click="goToPrevPhase">
                <v-icon color="primary" class="mr-2"> mdi-upload </v-icon>
                Upload de Exame
              </v-btn>
              <p class="mt-1 ml-1 caption">*Os exames em formato de arquivo não aparecem na tabela abaixo</p>
            </v-col>
            <v-col class="d-flex justify-end">
              <info-btn size="medium" @click="examsInfo = true" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <exams-table />
            </v-col>
          </v-row>
          <v-row> </v-row>
          <v-row>
            <v-col class="info-subtitle">
              <p>*De acordo com a literatura, recomenda-se não submeter o paciente a inúmeros exames laboratorias</p>
              <p>
                Referência: Zuberbier T et al. The EAACI/GA2LEN/EuroGuiDerm/APAAACI Guideline for the Definition,
                Classification, Diagnosis and Management of Urticaria. The 2021 Revision and Update. Allergy
              </p>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header> TESTES DE CONTATO </v-expansion-panel-header>
        <v-expansion-panel-content>
          <template v-if="phaseData.contactExams.length === 0 || addNewExam">
            <field-label label="Testes realizados em:">
              <v-row>
                <v-col class="d-flex flex-row gap-2 mt-2 col-lg-3 col-md-6 col-sm-4">
                  <text-field placeholder="mês" v-model="contactExam.month" @input="goToYear" />
                  <v-text-field placeholder="ano" v-model="contactExam.year" ref="year" outlined dense />
                </v-col>
              </v-row>
            </field-label>
            <field-label label="Marque abaixo, quais testes foram positivos">
              <v-row class="mt-2 flex-wrap" no-gutters>
                <v-col
                  v-for="option in contactExamsOptions"
                  :key="option.key"
                  class="ma-0 pa-1 col-lg-5 col-md-12 col-sm-5"
                >
                  <v-checkbox
                    v-model="contactExam.selected"
                    :value="option.label"
                    class="disease-checkbox ma-0 pa-0 pl-4"
                    :class="{ 'selected-checkbox': contactExam.selected.includes(option.label) }"
                    hide-details
                  >
                    <template v-slot:label
                      ><span class="checkbox-label">{{ option.label }}</span></template
                    >
                  </v-checkbox>
                </v-col>
              </v-row>
            </field-label>
            <field-label class="mt-8" label="Anotações">
              <text-area :readonly="disabled" :max-length="2000" v-model="contactExam.notes" />
            </field-label>
            <v-row>
              <v-spacer />
              <v-col class="d-flex justify-end">
                <v-btn color="primary" class="white--text" @click="saveContactExam">adicionar</v-btn>
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <v-row>
              <v-col>
                <v-btn block class="white--text" color="primary" @click="addNewExam = true">{{
                  $vuetify.breakpoint.mdAndUp ? 'adicionar novo teste de contato' : 'novo teste de contato'
                }}</v-btn>
              </v-col>
            </v-row>
          </template>
          <v-row>
            <v-col
              class="col-lg-4 col-md-8 col-sm-5"
              v-for="(exam, index) in phaseData.contactExams"
              :key="index + '_contactExamCard'"
            >
              <v-card @click="openExamDialog(exam)" style="height: 100%">
                <v-card-title>
                  {{ 'Exame #' + (index + 1) + ' (' + exam.month + '/' + exam.year + ')' }}
                </v-card-title>
                <v-card-text>
                  {{ getExamsText(index) }}
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog v-model="examsInfo" max-width="50vw">
      <v-card class="pa-8">
        <v-card-text class="pa-0 d-flex align-center">
          <p class="ma-0">
            *Para investigação de UCE são necessários apenas: Hemograma completo, VHS ou PCR Alterações nesse exames
            podem ser suspeitas para outras doenças urticariformes como a urticária vasculite, por exemplo.
            <br />
            *Para prognóstico do tratamento da UCE (opcional): IgE total e anti-TPO
            <br />
            *De acordo com a literatura, recomenda-se não submeter o paciente a inúmeros exames laboratorias Referência:
            Zuberbier T et al. The EAACI/GA2LEN/EuroGuiDerm/APAAACI Guideline for the Definition, Classification,
            Diagnosis and Management of Urticaria. The 2021 Revision and Update. Allergy
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="examDialogData.visible" max-width="50vw">
      <v-card>
        <v-card-title> Data: {{ examDialogData.data }} </v-card-title>
        <v-card-text>
          <v-row>
            <v-col class="d-flex flex-row gap-2 flex-wrap">
              <v-chip v-for="(exam, index) in examDialogData.selected" :key="index + '_examDialogChips'">{{
                exam
              }}</v-chip>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <field-label class="mt-8" label="Anotações">
                <text-area :readonly="disabled" :max-length="2000" v-model="examDialogData.notes" :disabled="true" />
              </field-label>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import BasePhase from '@/components/AttendanceForm/general/phase/BasePhase.vue'
import InfoBtn from '@/components/InfoBtn.vue'
import ExamsTable from '@/components/ExamsTable.vue'
import TextField from '@/components/TextField.vue'
import FieldLabel from '@/components/FieldLabel.vue'
import { CONTACT_EXAMS_OPTIONS } from '@/components/AttendanceForm/csu/constants/contactExams'
import TextArea from '@/components/TextArea.vue'
import { createNamespacedHelpers } from 'vuex'

const { mapActions: attendanceActionsMap } = createNamespacedHelpers('attendance')

export default {
  components: { InfoBtn, ExamsTable, TextField, FieldLabel, TextArea },
  extends: BasePhase,
  data() {
    return {
      addNewExam: false,
      examsInfo: false,
      examUpload: false,
      contactExam: {
        month: null,
        year: null,
        selected: [],
        notes: null,
      },
      examDialogData: {
        visible: false,
        data: null,
        selected: null,
        notes: null,
      },
    }
  },
  computed: {
    contactExamsOptions() {
      return CONTACT_EXAMS_OPTIONS
    },
  },
  methods: {
    ...attendanceActionsMap(['prevPhase']),
    getDefaultData() {
      const data = {
        contactExams: [],
      }
      return data
    },
    saveContactExam() {
      this.phaseData.contactExams.push(this.contactExam)
      this.contactExam = {
        month: null,
        year: null,
        selected: [],
        notes: null,
      }
      this.addNewExam = false
    },
    goToYear() {
      if (this.contactExam.month.length === 2) {
        this.$refs.year.focus()
      }
    },
    getExamsText(index) {
      return (
        this.phaseData.contactExams[index].selected.slice(0, 4).join(', ') +
        (this.phaseData.contactExams[index].selected.length > 4 ? ' e outros' : '.')
      )
    },
    goToPrevPhase() {
      this.prevPhase()
    },
    openExamDialog(exam) {
      this.examDialogData = {
        visible: true,
        data: exam.month + '/' + exam.year,
        selected: exam.selected,
        notes: exam.notes,
      }
    },
  },
}
</script>

<style scoped>
.info-subtitle {
  font-weight: 500;
  font-size: 14px;
  color: #78909c;
}
.disease-checkbox {
  border: 2px solid #33333330;
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  border-radius: 10px;
}
.checkbox-label {
  padding: 16px 16px 16px 0;
  height: 100%;
}
.selected-checkbox {
  border: 2px solid #1976d2;
}
</style>
